import { buildEmailMap } from './emailMatch.js';

const API_BASE = import.meta.env.VITE_API_BASE_URL;

// Returns a Map (keyed by full email AND local part) usable with matchByEmail()
// for cross-domain lookups. Each record: { email, headshotUrl, bio, skills[], projects[], syncedAt }
export async function getOpenAssetEmployees(token) {
  if (!API_BASE) return new Map();

  try {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const res = await fetch(`${API_BASE}/openasset/employees`, { headers });
    if (!res.ok) throw new Error(`OpenAsset API ${res.status}`);

    const employees = await res.json();
    return buildEmailMap(employees);
  } catch (err) {
    console.warn('OpenAsset fetch failed (non-fatal):', err.message);
    return new Map();
  }
}
